module.exports = __webpack_public_path__ + "static/img/register-corp.808d9f97.png";